var map = {
	"./cross-icon.svg": 7411,
	"./css.svg": 2192,
	"./dart.svg": 652,
	"./dev.svg": 9286,
	"./email.svg": 7882,
	"./github.svg": 8866,
	"./html.svg": 7218,
	"./icon-app-design.svg": 4198,
	"./icon-front.svg": 5341,
	"./instagram.svg": 673,
	"./java.svg": 6522,
	"./javascript.svg": 3173,
	"./linkedin.svg": 8500,
	"./menu-icon.svg": 8054,
	"./programmer.svg": 9764,
	"./react.svg": 9978,
	"./styled.svg": 7855,
	"./tailwind-css.svg": 5794,
	"./team-work.svg": 9941,
	"./typescript.svg": 3328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;